'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'tag';
var width = 448;
var height = 512;
var aliases = [127991];
var unicode = 'f02b';
var svgPathData = 'M224 457.4L16 249.4 16 48l201.4 0 208 208L224 457.4zM436.7 244.7L224 32 16 32 0 32 0 48 0 256 212.7 468.7 224 480l11.3-11.3L436.7 267.3 448 256l-11.3-11.3zM112 184a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM88 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTag = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;